import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from '../../models/response.model';
import { appEnv } from '../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class RateScopeService {

  constructor(private http: HttpClient) { }

  /** shiftTypeId omitted or 0 returns every rate scope, unfiltered. */
  getAll (shiftTypeId: number = 0): Observable<ResponseModel> {
    const query = shiftTypeId ? `?shift_type_id=${shiftTypeId}` : '';
    return this.http.get<ResponseModel>(`${appEnv.api}rate-scopes${query}`);
  }
}
